import { render, staticRenderFns } from "./incomestatement.vue?vue&type=template&id=2b376278&scoped=true"
import script from "./incomestatement.vue?vue&type=script&lang=js"
export * from "./incomestatement.vue?vue&type=script&lang=js"
import style0 from "./incomestatement.vue?vue&type=style&index=0&id=2b376278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b376278",
  null
  
)

export default component.exports